// Port di globalDirectives.js (Vue 2) → plugin Vue 3.
// Vue 2 usava vue-clickaway (`v-click-outside`). vue-clickaway è Vue 2 only:
// qui la direttiva è reimplementata nativamente con stessa API
//   v-click-outside="handler"
// (handler chiamato quando il click avviene fuori dall'elemento).

const clickOutside = {
  beforeMount(el, binding) {
    el.__clickOutsideHandler__ = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event)
      }
    }
    document.addEventListener('click', el.__clickOutsideHandler__, true)
  },
  unmounted(el) {
    document.removeEventListener('click', el.__clickOutsideHandler__, true)
    delete el.__clickOutsideHandler__
  },
}

const directives = {
  'click-outside': clickOutside,
}

export default {
  install(app) {
    Object.entries(directives).forEach(([name, def]) => {
      app.directive(name, def)
    })
  },
}
